import Image from 'next/legacy/image';
import Link from 'next/link';

import confetti from '/public/images/graduate/confetti.gif';
import hanghaeShip from '/public/images/graduate/scc_characters2x.png';
import sea from '/public/images/graduate/sea_web.png';
import logo from '/public/images/logo/logo.png';

import * as S from './style';

export default function Template({ graduateName }) {
  return (
    <S.Wrapper>
      <S.Contents>
        <Link href='/' passHref>
          <S.Logo>
            <Image src={logo} alt='logo' />
          </S.Logo>
        </Link>
        <S.Header>
          <S.Title>
            {graduateName}님,
            <br />
            <span>
              항해99 수료를
              <br />
              축하드립니다.
            </span>
          </S.Title>
          <S.HeaderImg>
            <S.ShipImg>
              <Image src={hanghaeShip} alt='hanghae_ship' />
            </S.ShipImg>
            <S.Confetti>
              {/* <video*/}
              {/*  src={`${process.env.NEXT_PUBLIC_CDN_BASE_URL}/hanghae99/confetti.mp4`}*/}
              {/*  width="100%"*/}
              {/*  muted*/}
              {/*  autoPlay*/}
              {/*  loop*/}
              {/* />*/}
              <Image src={confetti} layout='fill' objectFit='contain' />
            </S.Confetti>
          </S.HeaderImg>
        </S.Header>
      </S.Contents>
      <S.SeaImg>
        <Image src={sea} alt='sea' layout='fill' objectFit='fill' />
      </S.SeaImg>
    </S.Wrapper>
  );
}
